"use client";

import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
  className?: string;
}

export function LoadingScreen({
  message = "Loading...",
  fullScreen = false,
  className,
}: LoadingScreenProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        fullScreen
          ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm"
          : "min-h-[400px] w-full",
        className
      )}
    >
      <div className="flex flex-col items-center gap-4">
        {/* Animated spinner with pulsing effect */}
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping" />
          <div className="relative rounded-full bg-background p-3 shadow-lg">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        </div>

        {/* Loading text with subtle animation */}
        <div className="text-center">
          <p className="text-sm font-medium text-foreground animate-pulse">
            {message}
          </p>
          {/* Animated dots */}
          <div className="flex gap-1 justify-center mt-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:-0.3s]" />
            <div className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce [animation-delay:-0.15s]" />
            <div className="h-1.5 w-1.5 rounded-full bg-primary animate-bounce" />
          </div>
        </div>
      </div>
    </div>
  );
}





